import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface WaitlistData {
  nombre: string;
  apellido: string;
  telefono: string;
  correoElectronico: string;
  provincia: string;
  distrito: string;
  userId?: string;
  createdAt: string;
}

@Injectable({
  providedIn: 'root'
})
export class WaitlistService {
  private apiUrl = `${environment.apiUrl}/waitlist`;

  constructor(private http: HttpClient) {}

  // Registrar usuario en lista de espera
  registerToWaitlist(data: WaitlistData): Observable<any> {
    return this.http.post(`${this.apiUrl}/register`, data);
  }

  // Obtener registros de lista de espera (para admin)
  getWaitlistEntries(): Observable<any> {
    return this.http.get(`${this.apiUrl}`);
  }

  // Eliminar entrada de lista de espera (para admin)
  deleteWaitlistEntry(id: string): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`);
  }
}
